<div style="height: 550px;">
  <form [formGroup]="SettingsForm">

    <div class="mb-3 row" style="margin-bottom: 0px;">
      <div class="col-lg-12">
        <fieldset>
          <legend>TFTP Server Settings</legend>
        </fieldset>
      </div>
    </div>
    <div class="mb-3 row">
      <div class="col-lg-12" style="height: 5px;">
      </div>
    </div>
    <div class="mb-3 row">
      <div class="col-lg-2 form-control-static">
        Server Address:
      </div>
      <div class="col-lg-6">
        <input id="serverAddress" type="text" class="form-control tftp-text-field" [formControl]="serverAddress" />
      </div>
  </div>
  <div class="mb-3 row">
    <div class="col-lg-2 form-control-static">
      Server Port:
    </div>
    <div class="col-lg-2">
      <input id="serverPort" type="number" class="form-control" [formControl]="serverPort" />
    </div>
    @if (serverPort.hasError('minValue') || serverPort.hasError('maxValue')) {
      <div class="col-lg-4 alert alert-danger">
        This value must be in the range 1 - 65535
      </div>
    }
  </div>
  <div class="mb-3 row">
    <div class="col-lg-2 form-control-static">
      TFTP Folder:
    </div>
    <div class="col-lg-6">
      <input id="targetFolder" type="text" class="form-control tftp-text-field" [formControl]="targetFolder" />
    </div>
  </div>
  <div class="mb-3 row">
    <div class="col-lg-2 form-control-static">
      TFTP Directory:
    </div>
    <div class="col-lg-6">
      <input id="targetDir" type="text" class="form-control tftp-text-field" [formControl]="targetDir" />
    </div>
  </div>
  <div class="mb-3 row">
    <div class="col-lg-2 form-control-static">
      File Name Format:
    </div>
    <div class="col-lg-6">
      <input id="fileNameFormat" type="text" class="form-control tftp-text-field" [formControl]="fileNameFormat" />
    </div>
  </div>
  <div class="mb-3 row">
    <div class="col-lg-2 form-control-static">
      Wait For File Timeout:
    </div>
    <div class="col-lg-2">
      <input id="fileWaitTimeout" type="number" class="form-control" [formControl]="fileWaitTimeout" />
    </div>
    <div class="col-lg-2">
      <p class="form-control-static">(in seconds)</p>
    </div>
    @if (fileWaitTimeout.hasError('minValue') || fileWaitTimeout.hasError('maxValue')) {
      <div class="col-lg-4 alert alert-danger">
        This value must be in the range 0 - 3600
      </div>
    }
  </div>

  <div class="mb-3 row" style="margin-bottom: 0px;">
    <div class="col-lg-12">
      <fieldset>
        <legend>TFTP Authentication</legend>
      </fieldset>
    </div>
  </div>
  <div class="mb-3 row">
    <div class="col-lg-2">
      <span>&nbsp;</span>
    </div>
    <div class="col-lg-3 form-check">
      <input id="requireAuth" type="checkbox" [formControl]="requireAuth" />
      <span class="uv-checkbox-label">Require Authentication</span>
    </div>
  </div>
  <div class="mb-3 row">
    <div class="col-lg-2 form-control-static">
      Username:
    </div>
    <div class="col-lg-6">
      <input id="userName" type="text" class="form-control tftp-text-field" [formControl]="userName" />
    </div>
    @if (SettingsForm.hasError('userNameRequired')) {
      <div class="col-lg-3 alert alert-danger">
        This value is required
      </div>
    }
  </div>
  <div class="mb-3 row">
    <div class="col-lg-2 form-control-static">
      Password:
    </div>
    <div class="col-lg-6">
      <input id="password" type="password" class="form-control tftp-text-field" [formControl]="password" />
    </div>
    @if (SettingsForm.hasError('passwordRequired')) {
      <div class="col-lg-3 alert alert-danger">
        This value is required
      </div>
    }
  </div>

</form>
</div>

